module.exports = __webpack_public_path__ + "7a98bde59531a03189d1aa841d09efc0.svg";